import { useEffect, useState } from 'react';

import useGetInterview, { useGetInterviewReviewTabs } from '~hooks/query/review/useGetInterview';
import { useRouterQuery } from '~hooks/useRouterQuery';
import { InterviewReviewType } from '~types/review';

import BarChart from '../BarChart';
import Tabs from '../Tabs';
import { getRankedReviewList, RankedInterviewReviewItem } from './helper';
import * as S from './style';

export default function ChartContents() {
  const companyHash = useRouterQuery('companyId');
  const { data, status } = useGetInterview(companyHash);
  const { data: tabs } = useGetInterviewReviewTabs(companyHash);
  const [selectedTabId, setSelectedTabId] = useState<InterviewReviewType>();
  const [selectedChartList, setSelectedChartList] = useState<RankedInterviewReviewItem[]>();

  const handleClickTab = (tabId: InterviewReviewType) => {
    setSelectedTabId(tabId);

    if (data?.reviews) {
      setSelectedChartList(getRankedReviewList(data?.reviews[tabId].data));
    }
  };

  useEffect(() => {
    setSelectedTabId(data?.defaultSource);

    if (data?.reviews && data?.defaultSource) {
      setSelectedChartList(getRankedReviewList(data?.reviews[data?.defaultSource].data));
    }
  }, [data]);

  if (status !== 'success') {
    return null;
  }

  return (
    <div>
      <Tabs tabs={tabs} activeMenu={selectedTabId} onClick={handleClickTab} />
      {data.totalCount === 0 ? (
        <S.EmptyMessage>작성된 면접 리뷰가 없습니다.</S.EmptyMessage>
      ) : (
        <S.TotalCount>총 참여수 {data.totalCount}명</S.TotalCount>
      )}
      <S.BarChartWrapper>
        {selectedChartList?.map((item, index) => (
          <BarChart key={`${selectedTabId}-${index}`} item={item} isEmpty={data.totalCount === 0} />
        ))}
      </S.BarChartWrapper>
    </div>
  );
}
